// Live, queuing etc. interactions are only counted for a number of days to speed up the request.
export const COUNT_RANGE_DAYS = 3;
